<script lang="ts">
  import { TextParagraph, TextSection } from '$lib/components/text';
  import { PageHead } from '$lib/components/page';
  import { DividerHorizontal } from '$lib/components/divider';
  import imgMenu from '$lib/assets/excel/excel_queue_submenu.png';
  import imgStart from '$lib/assets/excel/excel_queue_start.gif';
  import imgRetry from '$lib/assets/excel/excel_queue_retry.gif';
  import imgConcurrency from '$lib/assets/excel/excel_queue_concurrency.gif';
</script>

<PageHead
  title="Fila de Consultas do Add-in de Excel para Consulta CNPJ"
  description="Aprenda a gerenciar a fila de consultas no add-in do CNPJá para Excel. Descubra como adicionar itens, iniciar, pausar e reprocessar falhas, além de ajustar a quantidade de consultas simultâneas conforme seu plano. Maximize a eficiência das suas consultas com nosso guia detalhado."
/>

<!-- Queue Summary -->
<TextSection title="Fila de Consultas" tag="h1">
  <TextParagraph>
    A fila de consultas armazena a lista de itens que você adicionou para processamento, este submenu permite gerenciar
    sua execução e paralelismo:
  </TextParagraph>

  <img class="mb-6 rounded" src={imgMenu} alt="Submenu de Fila de Consultas" />

  <TextParagraph>
    Para incluir novos itens, você utilizará o submenu de <b>Consulta CNPJ</b>, explicado mais adiante no guia.
  </TextParagraph>
</TextSection>

<DividerHorizontal />

<!-- Start / Stop -->
<TextSection tag="h2" title="Iniciar e Pausar">
  <TextParagraph>Inicia ou pausa a execução da lista atual:</TextParagraph>

  <img class="rounded" src={imgStart} alt="Demonstração de Iniciar e Pausar" />
</TextSection>

<DividerHorizontal />

<!-- Retry -->
<TextSection tag="h2" title="Reprocessar Falhas">
  <TextParagraph>
    Eventuais falhas podem ocorrer durante o processamento, por exemplo: falta de créditos, ultrapassar o limite por
    minuto ou erros em nosso serviço.
  </TextParagraph>

  <TextParagraph>
    Este botão fornece uma maneira rápida de reprocessar estes itens sem ter que selecioná-los individualmente:
  </TextParagraph>

  <img class="rounded" src={imgRetry} alt="Demonstração do Reprocessar Falhas" />
</TextSection>

<DividerHorizontal />

<!-- Concurrency -->
<TextSection tag="h2" title="Consultas Simultâneas">
  <TextParagraph>
    Ao selecionar uma lista de itens a serem consultados, eles serão enviados a nossa plataforma em order sequencial.
  </TextParagraph>

  <TextParagraph>
    Por padrão, as consultas serão processadas uma a uma. É possível aumentar esta quantidade pelo botão de
    <b>Consultas Simultâneas</b>.
  </TextParagraph>

  <TextParagraph>
    Mas lembre-se, existe um limite de consultas permitidas por minuto de acordo com o seu plano atual.
  </TextParagraph>

  <TextParagraph>
    No modo gratuito, é recomendado manter em 1 para evitar falhas de limite de consultas excedido:
  </TextParagraph>

  <img class="rounded" src={imgConcurrency} alt="Demonstração de Consultas Simultâneas" />
</TextSection>
